import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmailtemplate({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <defs>
        <filter
          x="-7%"
          y="-4.2%"
          width="114%"
          height="111.7%"
          filterUnits="objectBoundingBox"
          id="pic-emailtemplate_svg__a"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <filter
          x="-20.2%"
          y="-14.5%"
          width="140.3%"
          height="140.6%"
          filterUnits="objectBoundingBox"
          id="pic-emailtemplate_svg__c"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <rect id="pic-emailtemplate_svg__b" x={0} y={0} width={100} height={120} rx={4} />
        <path
          d="M39.727 34.647V1.042a.892.892 0 00-.891-.891H5.921a.892.892 0 00-.891.891v33.605h34.697z"
          id="pic-emailtemplate_svg__d"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h240v168H0z" />
        <path
          d="M178.5 155c-40.205-9.933-77 7.5-102 7.5-40.5 0-79.078-37.6-70.5-79C14.025 44.768 72.455 47.801 108 28c109.5-61 112.5 22 126 64s-13 73.5-55.5 63z"
          fill="#E9EDFB"
        />
        <path
          d="M232.85 134.72l-.314.624C223.74 152.48 204 161.3 178.5 155c-40.205-9.933-77 7.5-102 7.5-30.12 0-59.177-20.796-68.564-48.486 24.958 11.645 58.255 13.5 111.564-3.514 62.31-19.886 93.764 2.8 113.35 24.22z"
          fill="#8F9DD6"
          opacity={0.32}
        />
        <g transform="translate(72 27)">
          <use
            fill="#000"
            filter="url(#pic-emailtemplate_svg__a)"
            xlinkHref="#pic-emailtemplate_svg__b"
          />
          <use fill="#FFF" xlinkHref="#pic-emailtemplate_svg__b" />
          <path
            d="M39 70a1 1 0 011 1v4a1 1 0 01-1 1H11a1 1 0 01-1-1v-4a1 1 0 011-1h28zm30-12a1 1 0 011 1v4a1 1 0 01-1 1H11a1 1 0 01-1-1v-4a1 1 0 011-1h58zm20-12a1 1 0 011 1v4a1 1 0 01-1 1H11a1 1 0 01-1-1v-4a1 1 0 011-1h78zm0-12a1 1 0 011 1v4a1 1 0 01-1 1H11a1 1 0 01-1-1v-4a1 1 0 011-1h78z"
            fill="#E3E8E8"
          />
          <rect fill="#E3E8E8" x={10} y={16} width={24} height={12} rx={2} />
          <g fill="#8E9FCC">
            <path d="M29.165 99.477H18.56a.313.313 0 01-.312-.312V88.56c0-.172.14-.312.312-.312h10.605c.171 0 .312.14.312.312v10.605c0 .171-.14.312-.312.312zM17 88.247v11.23c0 .688.56 1.248 1.248 1.248h11.229a1.25 1.25 0 001.248-1.248v-11.23A1.25 1.25 0 0029.477 87h-11.23A1.25 1.25 0 0017 88.248z" />
            <path d="M33.154 95.208l.349-.306a1.248 1.248 0 000-1.878l-.35-.304a1.248 1.248 0 010-1.877l.35-.306a1.248 1.248 0 000-1.878l-.35-.306a1.248 1.248 0 010-1.877l.157-.13a1.067 1.067 0 00.017-1.623 1.243 1.243 0 01-.101-.101l-.012-.014a1.066 1.066 0 00-1.622.016l-.13.156a1.248 1.248 0 01-1.878 0l-.306-.351a1.248 1.248 0 00-1.877 0l-.306.35a1.248 1.248 0 01-1.878 0l-.306-.35a1.248 1.248 0 00-1.877 0l-.306.35a1.248 1.248 0 01-1.878 0l-.306-.35a1.248 1.248 0 00-1.877 0l-.306.35a1.248 1.248 0 01-1.878 0l-.13-.155a1.07 1.07 0 00-1.624-.018l-.014.016a1.243 1.243 0 01-.101.101 1.068 1.068 0 00.017 1.62l.156.13a1.248 1.248 0 010 1.878l-.349.306a1.248 1.248 0 000 1.878l.351.306c.568.497.568 1.38 0 1.877l-.35.306a1.248 1.248 0 000 1.878l.35.306c.568.497.568 1.38 0 1.877l-.349.306a1.248 1.248 0 000 1.878l.347.304c.57.497.57 1.38 0 1.877l-.167.14a1.058 1.058 0 00-.016 1.605l.025.023c.036.031.069.065.1.1l.006.007a1.06 1.06 0 001.606-.015l.14-.166c.498-.57 1.38-.57 1.878 0l.396.45c.45.515 1.25.515 1.7 0l.395-.45c.497-.57 1.38-.57 1.878 0l.395.45c.45.515 1.25.515 1.7 0l.396-.45c.497-.57 1.38-.57 1.878 0l.395.45c.45.515 1.25.515 1.7 0l.396-.45c.497-.57 1.38-.57 1.877 0l.133.156c.212.254.515.38.817.38.294 0 .59-.12.803-.364a.995.995 0 01.101-.102l.024-.021c.49-.427.485-1.19-.008-1.614l-.154-.133a1.25 1.25 0 01-.01-1.887l.337-.296a1.248 1.248 0 000-1.878l-.354-.298a1.25 1.25 0 010-1.88zm-2.32 6.864H17.109c-.688 0-1.247-.56-1.247-1.248V87.1c0-.688.559-1.248 1.247-1.248h13.725c.688 0 1.247.56 1.247 1.248v13.724a1.25 1.25 0 01-1.247 1.248z" />
          </g>
        </g>
        <path
          d="M93.832 120.1a.437.437 0 01-.389-.235c-.31-.581-.614-1.488-.317-2.504a.44.44 0 01.773-.143l1.133 1.493a.438.438 0 01-.295.705.44.44 0 01-.408-.176l-.38-.499c.058.248.15.489.271.712a.445.445 0 01-.388.647z"
          fill="#FFE266"
        />
        <path
          d="M95.971 124.175a2.97 2.97 0 01-2.869-2.213 2.969 2.969 0 012.118-3.62 2.969 2.969 0 013.62 2.118 2.97 2.97 0 01-2.869 3.715zm0-5.05a2.086 2.086 0 101.15 3.826 2.086 2.086 0 00-1.15-3.826z"
          fill="#FFE266"
        />
        <path
          d="M95.336 119.082a.441.441 0 01-.413-.286c-.017-.044-.373-.934-1.35-.873a.44.44 0 01-.052-.879c1.311-.078 2.032.912 2.227 1.446a.439.439 0 01-.412.592z"
          fill="#FFE266"
        />
        <path
          d="M96.418 121.523c0 .19.1.365.265.458a.525.525 0 00.53 0 .532.532 0 00.264-.458c0-.188-.1-.364-.264-.457a.528.528 0 00-.794.458z"
          fill="#FB8F23"
        />
        <path
          d="M185.832 136.096v-19.31a.551.551 0 00-.552-.552h-41.975a.551.551 0 00-.552.551v19.31a.551.551 0 00.552.552h41.975a.551.551 0 00.552-.551z"
          fill="#3D4F7F"
        />
        <g transform="translate(142 102)">
          <use
            fill="#000"
            filter="url(#pic-emailtemplate_svg__c)"
            xlinkHref="#pic-emailtemplate_svg__d"
          />
          <use fill="#FFF" xlinkHref="#pic-emailtemplate_svg__d" />
        </g>
        <path
          d="M150.362 139.366l11.076-10.345-18.685-12.238v22.583h7.61zm35.47 0v-22.583l-18.685 12.238 11.075 10.345h7.61z"
          fill="#56A"
        />
        <path
          d="M149.818 106.932h25.327v1.758h-25.327v-1.758zm0 3.858h13.172v1.758h-13.172v-1.758zm0 3.858h24.518v1.758h-24.518v-1.758zm0 3.858h23.335v1.758h-23.335v-1.758z"
          fill="#EAEDF6"
        />
        <path
          d="M142.753 138.773l21.54-14.09 21.539 14.09v1.6a2.242 2.242 0 01-2.243 2.243h-38.594a2.242 2.242 0 01-2.242-2.242v-1.6z"
          fill="#8E9FCC"
        />
      </g>
    </svg>
  );
}

SvgPicEmailtemplate.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmailtemplate.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmailtemplate svgRef={ref} {...props} />
));
export default ForwardRef;
